import { render, staticRenderFns } from "./t-chip.vue?vue&type=template&id=1ecf4da3"
import script from "./t-chip.vue?vue&type=script&setup=true&lang=ts"
export * from "./t-chip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports